<template>
  <v-row>
    <CommonTable
      v-if="type === 'generic-accumulator'"
      :list-array="
        (config &&
          config.filters &&
          config.filters.map((i, index) => ({ ...i, id: index }))) ||
          []
      "
      :create-item-callback="createItem"
      :update-item-callback="editItem"
      :delete-item-callback="deleteItem"
      :headers="headers"
      :slots="slots"
      :actions="actions"
      resource="source-adapters"
      can-add
      can-delete
      can-edit
      class="common-table"
    ></CommonTable>
    <v-col class="py-0" v-if="type === 'zaptec-ev-charger'">
      <CommonDialog
        :dialog="dialogCharger"
        :head-text="$t('source-adapters.create-charger')"
        :confirm-button="{
          text: $t('buttons.create'),
          icon: 'mdi-plus'
        }"
        :on-confirm="() => $refs['form-charger'].save()"
        :on-cancel="() => (dialogCharger = false)"
      >
        <FormChargerSourceAdapter
          ref="form-charger"
          :success-callback="addCharger"
          :charger="charger"
          :chargers="config.chargers"
        ></FormChargerSourceAdapter>
      </CommonDialog>
      <CommonDialog
        :dialog="dialogEditCharger"
        :head-text="$t('source-adapters.edit-charger')"
        :confirm-button="{
          text: $t('buttons.update'),
          icon: 'mdi-pencil'
        }"
        :on-confirm="() => $refs['form-charger'].save()"
        :on-cancel="() => (dialogEditCharger = false)"
      >
        <FormChargerSourceAdapter
          ref="form-charger"
          :success-callback="editCharger"
          :charger="editItemCharger"
          :chargers="
            (config.chargers || []).filter(
              i => i.chargerId !== editItemCharger.chargerId
            )
          "
        ></FormChargerSourceAdapter>
      </CommonDialog>
      <CommonDialog
        :dialog="dialogToken"
        :head-text="$t('source-adapters.create-token')"
        :confirm-button="{
          text: $t('buttons.create'),
          icon: 'mdi-plus'
        }"
        :on-confirm="() => $refs['form-token'].save()"
        :on-cancel="() => (dialogToken = false)"
      >
        <FormTokenSourceAdapter
          ref="form-token"
          :success-callback="addToken"
          :token="token"
          :tokens="config.tokens"
        ></FormTokenSourceAdapter>
      </CommonDialog>
      <CommonDialog
        :dialog="dialogEditToken"
        :head-text="$t('source-adapters.edit-token')"
        :confirm-button="{
          text: $t('buttons.update'),
          icon: 'mdi-pencil'
        }"
        :on-confirm="() => $refs['form-token'].save()"
        :on-cancel="() => (dialogEditToken = false)"
      >
        <FormTokenSourceAdapter
          ref="form-token"
          :success-callback="editToken"
          :token="editItemToken"
          :tokens="
            (config.tokens || []).filter(
              i => i.tokenId !== editItemToken.tokenId
            )
          "
        ></FormTokenSourceAdapter>
      </CommonDialog>
      <div class="table-container py-0">
        <table class="table" border="1" v-if="config">
          <tr>
            <th></th>
            <th
              v-for="(charger, index) in config.chargers"
              v-bind:key="charger.chargerId"
            >
              <div class="element-container">
                <v-btn
                  color="primary"
                  icon
                  x-small
                  dark
                  v-on:click="() => removeCharger(index)"
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ charger.tag }}</span>
                  </template>
                  <span>
                    {{ charger.chargerId }}
                    <br v-if="charger.notices" />{{ charger.notices }}
                  </span>
                </v-tooltip>

                <v-btn
                  color="primary"
                  icon
                  x-small
                  dark
                  v-on:click="() => openEditChargerDialog(index)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </div>
            </th>
            <th>
              <v-btn v-on:click="dialogCharger = true" color="primary" block>
                <v-icon class="mr-2">mdi-plus</v-icon>
                {{ $t("source-adapters.add") }}
              </v-btn>
            </th>
          </tr>
          <tr>
            <th>
              <div class="element-container">
                <span><v-icon small>mdi-asterisk</v-icon></span>
              </div>
            </th>
            <td
              v-for="charger in config.chargers"
              v-bind:key="'* ' + charger.chargerId"
            >
              <v-checkbox
                :input-value="charger.tokens.findIndex(i => i === '*') !== -1"
                @click.native="() => setAsterisks(charger)"
              ></v-checkbox>
            </td>
            <td></td>
          </tr>
          <tr>
            <th>
              <div class="element-container">
                <span><v-icon>mdi-arrow-down</v-icon></span>
              </div>
            </th>
            <td
              v-for="charger in config.chargers"
              v-bind:key="'↓ ' + charger.chargerId"
            >
              <v-checkbox
                :input-value="
                  (charger.tokens || []).filter(i => i !== '*').length ===
                    config.tokens.length
                "
                :disabled="charger.tokens.findIndex(i => i === '*') !== -1"
                @click.native="() => setAllTokenForCharger(charger)"
              ></v-checkbox>
            </td>
            <td></td>
          </tr>
          <tr v-for="(token, index) in config.tokens" v-bind:key="token.token">
            <th>
              <div class="element-container">
                <v-btn
                  color="primary"
                  icon
                  x-small
                  dark
                  v-on:click="() => removeToken(index)"
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ token.tag }}</span>
                  </template>
                  <span>
                    {{ token.token }}
                    <br v-if="token.notices" />{{ token.notices }}
                  </span>
                </v-tooltip>
                <v-btn
                  color="primary"
                  icon
                  x-small
                  dark
                  v-on:click="() => openEditTokenDialog(index)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </div>
            </th>
            <td
              v-for="charger in config.chargers"
              v-bind:key="token.token + ' ' + charger.chargerId"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-checkbox
                    v-on="on"
                    :input-value="
                      charger.tokens.findIndex(i => i === token.tag) !== -1
                    "
                    :disabled="charger.tokens.findIndex(i => i === '*') !== -1"
                    @click.native="() => setTokenForCharger(charger, token)"
                  ></v-checkbox>
                </template>
                <span> {{ token.tag }}/{{ charger.tag }} </span>
              </v-tooltip>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <v-btn v-on:click="dialogToken = true" color="primary" block>
                <v-icon class="mr-2">mdi-plus</v-icon>
                {{ $t("source-adapters.add") }}
              </v-btn>
            </td>
            <td
              v-for="charger in config.chargers"
              v-bind:key="'helper  ' + charger.chargerId"
            ></td>
            <td></td>
          </tr>
        </table>
      </div>
    </v-col>
    <v-col class="py-0" v-if="type === 'ocpp-proxy'">
      <CommonDialog
        :dialog="dialogCharger"
        :head-text="$t('source-adapters.create-charger')"
        :confirm-button="{
          text: $t('buttons.create'),
          icon: 'mdi-plus'
        }"
        :on-confirm="() => $refs['form-charger'].save()"
        :on-cancel="() => (dialogCharger = false)"
      >
        <FormChargerSourceAdapter
          ref="form-charger"
          :success-callback="addCharger"
          :charger="charger"
          :chargers="config.chargers"
        ></FormChargerSourceAdapter>
      </CommonDialog>
      <CommonDialog
        :dialog="dialogEditCharger"
        :head-text="$t('source-adapters.edit-charger')"
        :confirm-button="{
          text: $t('buttons.update'),
          icon: 'mdi-pencil'
        }"
        :on-confirm="() => $refs['form-charger'].save()"
        :on-cancel="() => (dialogEditCharger = false)"
      >
        <FormChargerSourceAdapter
          ref="form-charger"
          :success-callback="editCharger"
          :charger="editItemCharger"
          :chargers="
            (config.chargers || []).filter(
              i => i.chargerId !== editItemCharger.chargerId
            )
          "
        ></FormChargerSourceAdapter>
      </CommonDialog>
      <CommonDialog
        :dialog="dialogToken"
        :head-text="$t('source-adapters.create-token')"
        :confirm-button="{
          text: $t('buttons.create'),
          icon: 'mdi-plus'
        }"
        :on-confirm="() => $refs['form-token'].save()"
        :on-cancel="() => (dialogToken = false)"
      >
        <FormTokenSourceAdapter
          ref="form-token"
          :success-callback="addToken"
          :token="token"
          :tokens="config.tokens"
        ></FormTokenSourceAdapter>
      </CommonDialog>
      <CommonDialog
        :dialog="dialogEditToken"
        :head-text="$t('source-adapters.edit-token')"
        :confirm-button="{
          text: $t('buttons.update'),
          icon: 'mdi-pencil'
        }"
        :on-confirm="() => $refs['form-token'].save()"
        :on-cancel="() => (dialogEditToken = false)"
      >
        <FormTokenSourceAdapter
          ref="form-token"
          :success-callback="editToken"
          :token="editItemToken"
          :tokens="
            (config.tokens || []).filter(
              i => i.tokenId !== editItemToken.tokenId
            )
          "
        ></FormTokenSourceAdapter>
      </CommonDialog>
      <div class="table-container py-0">
        <table class="table" border="1" v-if="config">
          <tr>
            <th></th>
            <th
              v-for="(charger, index) in config.chargers"
              v-bind:key="charger.chargerId"
            >
              <div class="element-container">
                <v-btn
                  color="primary"
                  icon
                  x-small
                  dark
                  v-on:click="() => removeCharger(index)"
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ charger.tag }}</span>
                  </template>
                  <span>
                    {{ charger.chargerId }}
                    <br v-if="charger.notices" />{{ charger.notices }}
                  </span>
                </v-tooltip>

                <v-btn
                  color="primary"
                  icon
                  x-small
                  dark
                  v-on:click="() => openEditChargerDialog(index)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </div>
            </th>
            <th>
              <v-btn v-on:click="dialogCharger = true" color="primary" block>
                <v-icon class="mr-2">mdi-plus</v-icon>
                {{ $t("source-adapters.add") }}
              </v-btn>
            </th>
          </tr>
          <tr>
            <th>
              <div class="element-container">
                <span><v-icon small>mdi-asterisk</v-icon></span>
              </div>
            </th>
            <td
              v-for="charger in config.chargers"
              v-bind:key="'* ' + charger.chargerId"
            >
              <v-checkbox
                :input-value="charger.tokens.findIndex(i => i === '*') !== -1"
                @click.native="() => setAsterisks(charger)"
              ></v-checkbox>
            </td>
            <td></td>
          </tr>
          <tr>
            <th>
              <div class="element-container">
                <span><v-icon>mdi-arrow-down</v-icon></span>
              </div>
            </th>
            <td
              v-for="charger in config.chargers"
              v-bind:key="'↓ ' + charger.chargerId"
            >
              <v-checkbox
                :input-value="
                  (charger.tokens || []).filter(i => i !== '*').length ===
                    config.tokens.length
                "
                :disabled="charger.tokens.findIndex(i => i === '*') !== -1"
                @click.native="() => setAllTokenForCharger(charger)"
              ></v-checkbox>
            </td>
            <td></td>
          </tr>
          <tr v-for="(token, index) in config.tokens" v-bind:key="token.token">
            <th>
              <div class="element-container">
                <v-btn
                  color="primary"
                  icon
                  x-small
                  dark
                  v-on:click="() => removeToken(index)"
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ token.tag }}</span>
                  </template>
                  <span>
                    {{ token.token }}
                    <br v-if="token.notices" />{{ token.notices }}
                  </span>
                </v-tooltip>
                <v-btn
                  color="primary"
                  icon
                  x-small
                  dark
                  v-on:click="() => openEditTokenDialog(index)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </div>
            </th>
            <td
              v-for="charger in config.chargers"
              v-bind:key="token.token + ' ' + charger.chargerId"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-checkbox
                    v-on="on"
                    :input-value="
                      charger.tokens.findIndex(i => i === token.tag) !== -1
                    "
                    :disabled="charger.tokens.findIndex(i => i === '*') !== -1"
                    @click.native="() => setTokenForCharger(charger, token)"
                  ></v-checkbox>
                </template>
                <span> {{ token.tag }}/{{ charger.tag }} </span>
              </v-tooltip>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <v-btn v-on:click="dialogToken = true" color="primary" block>
                <v-icon class="mr-2">mdi-plus</v-icon>
                {{ $t("source-adapters.add") }}
              </v-btn>
            </td>
            <td
              v-for="charger in config.chargers"
              v-bind:key="'helper  ' + charger.chargerId"
            ></td>
            <td></td>
          </tr>
        </table>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { rules } from "../../../mixins/rules";
import { projectPermissions } from "../../../mixins/projects/projectPermissions";
import CommonTable from "../../../common/tables/CommonTable";
import CommonDialog from "../../../common/dialogs/CommonDialog";
import FormTokenSourceAdapter from "./FormTokenSourceAdapter";
import FormChargerSourceAdapter from "./FormChargerSourceAdapter";
export default {
  name: "ConfigSourceAdapter",
  mixins: [rules, projectPermissions],
  components: {
    CommonTable,
    CommonDialog,
    FormTokenSourceAdapter,
    FormChargerSourceAdapter
  },
  data: function() {
    return {
      dialogCharger: false,
      dialogToken: false,
      dialogEditCharger: false,
      dialogEditToken: false,
      charger: {
        tag: "",
        tokens: [],
        notices: "",
        chargerId: ""
      },
      token: {
        tag: "",
        notices: "",
        token: ""
      },
      editItemCharger: {
        tag: "",
        tokens: [],
        notices: "",
        chargerId: ""
      },
      editItemToken: {
        tag: "",
        notices: "",
        token: ""
      },
      loading: false,
      options: {
        lineNumbers: true,
        foldGutter: true,
        gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
        mode: "application/json"
      },
      config: {},
      headers: [
        {
          text: this.$t("source-adapters.tag"),
          align: "left",
          value: "tag",
          sortable: false
        },
        {
          text: this.$t("source-adapters.type"),
          value: "type",
          sortable: false
        },
        {
          text: this.$t("source-adapters.string"),
          value: "string",
          sortable: false
        },
        {
          text: this.$t("source-adapters.action"),
          value: "action",
          align: "right",
          sortable: false
        }
      ],
      actions: []
    };
  },
  props: {
    resourceLoading: {
      type: Boolean,
      default: false
    },
    configString: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    }
  },
  computed: {
    slots() {
      let rules = this.rules;
      return [
        {
          name: "tag",
          title: "tag",
          form: {
            type: "text",
            rules: [rules.required]
          }
        },
        {
          name: "type",
          title: "type",
          form: {
            type: "select",
            name: "type",
            items: this.filter_types,
            rules: [rules.required]
          }
        }
      ];
    },
    filter_types() {
      return this.$store.getters[
        "projectMeteringStore/ingestionStore/getFilterTypes"
      ];
    }
  },
  methods: {
    formConfig() {
      this.config = this.configString && JSON.parse(this.configString);
    },
    createItem(item) {
      this.config.filters.unshift(item);
    },
    editItem(item) {
      let { id, ...itemWithOutId } = item;
      this.$set(this.config.filters, id, itemWithOutId);
    },
    deleteItem(id) {
      this.config.filters.splice(id, 1);
    },
    addCharger() {
      this.config.chargers.push(this.charger);
      this.$set(this, "charger", {
        tag: "",
        tokens: [],
        notices: "",
        chargerId: ""
      });
      this.dialogCharger = false;
    },
    addToken() {
      this.config.tokens.push(this.token);
      this.$set(this, "token", {
        tag: "",
        notices: "",
        token: ""
      });
      this.dialogToken = false;
    },
    isUniqueCharger(value) {
      return (
        this.config.chargers.findIndex(i => i.chargerId === value) === -1 ||
        this.$t("source-adapters.charger-id-should-by-unique")
      );
    },
    setTokenForCharger(charger, token) {
      let index = charger.tokens.findIndex(i => i === token.tag);
      if (index === -1) {
        charger.tokens.push(token.tag);
      } else {
        charger.tokens.splice(index, 1);
      }
    },
    setAllTokenForCharger(charger) {
      let asterisks = charger.tokens.find(i => i === "*");
      if (
        (charger.tokens || []).filter(i => i !== "*").length ===
        this.config.tokens.length
      ) {
        charger.tokens = [];
      } else {
        charger.tokens = this.config.tokens.map(i => i.tag);
      }
      if (asterisks) {
        charger.tokens.push("*");
      }
    },
    setAsterisks(charger) {
      let asterisks = charger.tokens.find(i => i === "*");
      charger.tokens = [];
      if (!asterisks) {
        charger.tokens.push("*");
      }
    },
    removeToken(index) {
      this.config.tokens.splice(index, 1);
    },
    removeCharger(index) {
      this.config.chargers.splice(index, 1);
    },
    openEditChargerDialog(index) {
      this.editItemCharger = { ...this.config.chargers[index], index };
      this.dialogEditCharger = true;
    },
    editCharger(chargerParams) {
      let { index, ...charger } = chargerParams;
      this.$set(this.config.chargers, index, charger);
      this.dialogEditCharger = false;
    },
    openEditTokenDialog(index) {
      this.editItemToken = { ...this.config.tokens[index], index };
      this.dialogEditToken = true;
    },
    editToken(tokenParams) {
      let { index, ...token } = tokenParams;
      this.$set(this.config.tokens, index, token);
      this.dialogEditToken = false;
    }
  },
  watch: {
    configString() {
      this.formConfig();
    },
    config: {
      handler() {
        this.$emit("update:configString", JSON.stringify(this.config, null, 4));
      },
      deep: true
    }
  },
  mounted() {
    this.formConfig();
  }
};
</script>
<style lang="scss" scoped>
.common-table {
  height: auto;
}
.config-error-bag::v-deep .v-input__slot {
  display: none !important;
}
.table-container {
  width: 100%;
  overflow: auto;
}
.table {
  border-spacing: 0;
  border-color: #c1c1c1;
  border-style: solid;
  border-left: 0;
  border-top: 0;
  th {
    padding: 0;
    border-style: solid;
  }
  td,
  th {
    border-style: solid;
    border-color: #c1c1c1 !important;
    border-right: 0;
    border-bottom: 0;
  }
  tr:first-child > * {
    background: #e5e5e5;
  }
  tr:first-child > th:first-child {
    background: white;
  }
  tr:nth-child(2n + 3) {
    background: rgba(229, 229, 229, 0.55);
  }
  &::v-deep .v-input {
    margin: 6px 0 2px;
    .v-messages {
      display: none;
    }
    .v-input__slot {
      justify-content: center;
    }
  }
}
.element-container {
  display: flex;
  justify-content: space-between;
  text-align: center;
  align-items: center;
  padding: 0.7ex;
  span {
    flex: 1;
    display: inline-block;
    padding: 0 0.7ex;
  }
}
</style>
